// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dm-page {
    width: 100%;
    min-width: 0;
    color: #203047;
  }
  
  .dm-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
  }
  
  .dm-heading h2 {
    font-size: 23px;
    margin: 0 0 5px;
    display: flex;
    align-items: center;
    gap: 9px;
  }
  
  .dm-heading p {
    margin: 0;
    color: #8190a4;
    font-size: 13px;
  }
  
  .dm-total {
    font-size: 13px;
    color: #51759d;
    background: #edf5ff;
    padding: 9px 14px;
    border-radius: 9px;
  }
  
  .dm-panel {
    background: #fff;
    border: 1px solid #e4eaf1;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 12px #19355409;
  }
  
  .dm-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }
  
  .dm-tabs {
    display: flex;
    gap: 8px;
  }
  
  .dm-tabs button {
    border: 1px solid #dce4ee;
    border-radius: 8px;
    background: #f5f7fa;
    color: #617187;
    padding: 11px 22px;
    font-weight: 700;
    cursor: pointer;
  }
  
  .dm-tabs button.dm-selected {
    background: #168ff0;
    border-color: #168ff0;
    color: white;
  }
  
  .dm-search {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #dce4ee;
    border-radius: 8px;
    padding: 5px 6px 5px 12px;
    color: #8494a5;
  }
  
  .dm-search input {
    border: 0;
    outline: 0;
    min-width: 240px;
    font-size: 13px;
    padding: 7px 2px;
    background: transparent;
  }
  
  .dm-search button {
    display: flex;
    align-items: center;
    gap: 4px;
    border: 0;
    background: #edf2f7;
    border-radius: 6px;
    padding: 8px 10px;
    cursor: pointer;
    color: #516479;
  }
  
  .dm-count {
    margin: 24px 0 10px;
    color: #728198;
    font-size: 13px;
  }
  
  .dm-count strong {
    color: #203047;
  }
  
  .dm-table-wrap {
    overflow-x: auto;
  }
  
  .dm-table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    text-align: center;
    font-size: 13px;
  }
  
  .dm-table th {
    background: #f4f7fb;
    color: #43536b;
    font-weight: 700;
    padding: 15px 12px;
    border-top: 1px solid #dce5f0;
    border-bottom: 1px solid #dce5f0;
    white-space: nowrap;
  }
  
  .dm-table td {
    padding: 15px 12px;
    border-bottom: 1px solid #edf0f5;
    white-space: nowrap;
  }
  
  .dm-table tbody tr:hover {
    background: #f8fbff;
  }
  
  .dm-id {
    font-weight: 600;
    color: #365a85;
  }
  
  .dm-time {
    color: #52647a;
  }
  
  .dm-status {
    display: inline-block;
    min-width: 57px;
    padding: 5px 9px;
    border-radius: 5px;
    font-weight: 700;
  }
  
  .dm-ok {
    background: #e4f7eb;
    color: #149457;
  }
  
  .dm-bad {
    background: #ffe9e9;
    color: #d64343;
  }
  
  .dm-empty {
    padding: 50px !important;
    color: #8895a6;
  }
  
  .dm-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-top: 20px;
    color: #7b8a9b;
    font-size: 13px;
  }
  
  .dm-pagination {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
  }
  
  .dm-pagination button {
    background: white;
    border: 1px solid #e0e6ee;
    border-radius: 6px;
    padding: 7px 11px;
    color: #52637b;
    cursor: pointer;
  }
  
  .dm-pagination button.dm-current {
    background: #168ff0;
    color: #fff;
    border-color: #168ff0;
  }
  
  .dm-pagination button:disabled {
    opacity: .4;
    cursor: default;
  }
  
  .dm-note {
    color: #8b98aa;
    font-size: 12px;
    margin: 14px 3px;
  }
  
  @media (max-width: 900px) {
    .dm-heading {
      align-items: flex-start;
    }
    .dm-toolbar {
      align-items: stretch;
    }
    .dm-search {
      width: 100%;
    }
    .dm-search input {
      min-width: 0;
      flex: 1 1;
    }
    .dm-footer {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  
  /* 장비관리 표 영역 높이 유지 */

  /* 장비 관리 리디자인 페이지 레이아웃 */
.device-management-layout .device-management-content {
  flex: 1 1;
  min-width: 0;
  padding: 20px 28px 24px;
  box-sizing: border-box;
}

.device-management-layout .dm-page {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.device-management-layout .dm-panel {
  width: 100%;
  max-width: none;
  box-sizing: border-box;
}

/* =========================================
   장비 관리 글씨 크기 통일
   사용자 관리 목록과 동일한 기준
========================================= */

/* 페이지 제목 */
.device-management-layout .dm-heading h2 {
  font-size: 24px;
}

/* 설명 및 전체 건수 */
.device-management-layout .dm-heading p,
.device-management-layout .dm-total {
  font-size: 14px;
}

/* 플러그 / 스위치 / 감지기 탭 */
.device-management-layout .dm-tabs button {
  font-size: 15px;
}

/* 검색창 */
.device-management-layout .dm-search input,
.device-management-layout .dm-search button {
  font-size: 14px;
}

/* 목록 건수 */
.device-management-layout .dm-count {
  font-size: 16px;
  margin: 18px 0 10px;
}

/* 장비 목록 */
.device-management-layout .dm-table {
  font-size: 15px;
}

/* 테이블 헤더 */
.device-management-layout .dm-table th {
  font-size: 15px;
  padding: 12px 9px;
}

/* 테이블 데이터 */
.device-management-layout .dm-table td {
  font-size: 15px;
  padding: 10px 9px;
}

/* 상태 표시 */
.device-management-layout .dm-status {
  font-size: 14px;
}

/* 페이지네이션 */
.device-management-layout .dm-footer,
.device-management-layout .dm-pagination button {
  font-size: 14px;
}

.device-management-layout .dm-footer {
  margin-top: 14px;
}

/* 하단 안내 문구 */
.device-management-layout .dm-note {
  font-size: 13px;
}

/* 장비 관리 테이블 세로 공간 활용 */

/* 테이블 헤더 */
.device-management-layout .dm-table th {
  padding: 17px 9px;
}

/* 테이블 데이터 행 */
.device-management-layout .dm-table td {
  padding: 17px 9px;
}

/* 테이블과 페이지네이션 사이 */
.device-management-layout .dm-footer {
  margin-top: 20px;
}

/* 하단 안내 문구 */
.device-management-layout .dm-note {
  margin-top: 18px;
}
/* 사용자관리 기준 디자인 통일 */
.dm-page {
  color: #26354a;
  font-family: 'Malgun Gothic', Arial, sans-serif;
}

.dm-heading h2 {
  font-size: 21px;
  margin-bottom: 6px;
}

.dm-panel {
  padding: 22px;
  border-radius: 10px;
}

.dm-table {
  font-size: 12px;
}

.dm-table th {
  background: #f1f5fa;
  color: #3b4c62;
  border-top: 2px solid #2196f3;
  border-bottom: none;
  padding: 14px 9px;
}

.dm-table td {
  padding: 13px 9px;
  border-bottom: 1px solid #e8edf3;
}

.dm-table tbody tr:hover {
  background: #f1f8ff;
}

.dm-pagination button {
  border-radius: 5px;
  padding: 7px 10px;
}

.dm-footer {
  font-size: 12px;
}

/* 페이지 이동 시 테이블 높이 및 셀 크기 고정 */
.dm-table-wrap {
  min-height: 565px;
}

.dm-table {
  table-layout: fixed;
}

.dm-table thead tr {
  height: 48px;
}

.dm-table tbody tr {
  height: 55px;
}

.dm-table td {
  box-sizing: border-box;
  height: 55px;
  vertical-align: middle;
}

.dm-table .dm-time {
  white-space: nowrap;
}

/* 장비관리 설치위치 전체 주소 표시 */
.dm-table td.dm-location {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: keep-all;
  text-align: left;
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/device/DeviceManagementRedesign.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,WAAW;IACb;IACA;MACE,YAAY;MACZ,SAAO;IACT;IACA;MACE,sBAAsB;MACtB,uBAAuB;IACzB;EACF;;EAEA,oBAAoB;;EAEpB,wBAAwB;AAC1B;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;;;2CAG2C;;AAE3C,WAAW;AACX;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;;EAEE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,eAAe;AACjB;;AAEA,QAAQ;AACR;;EAEE,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,eAAe;AACjB;;AAEA,WAAW;AACX;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,eAAe;AACjB;;AAEA,uBAAuB;;AAEvB,WAAW;AACX;EACE,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;AACA,oBAAoB;AACpB;EACE,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".dm-page {\n    width: 100%;\n    min-width: 0;\n    color: #203047;\n  }\n  \n  .dm-heading {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 18px;\n  }\n  \n  .dm-heading h2 {\n    font-size: 23px;\n    margin: 0 0 5px;\n    display: flex;\n    align-items: center;\n    gap: 9px;\n  }\n  \n  .dm-heading p {\n    margin: 0;\n    color: #8190a4;\n    font-size: 13px;\n  }\n  \n  .dm-total {\n    font-size: 13px;\n    color: #51759d;\n    background: #edf5ff;\n    padding: 9px 14px;\n    border-radius: 9px;\n  }\n  \n  .dm-panel {\n    background: #fff;\n    border: 1px solid #e4eaf1;\n    border-radius: 12px;\n    padding: 20px;\n    box-shadow: 0 2px 12px #19355409;\n  }\n  \n  .dm-toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n    flex-wrap: wrap;\n  }\n  \n  .dm-tabs {\n    display: flex;\n    gap: 8px;\n  }\n  \n  .dm-tabs button {\n    border: 1px solid #dce4ee;\n    border-radius: 8px;\n    background: #f5f7fa;\n    color: #617187;\n    padding: 11px 22px;\n    font-weight: 700;\n    cursor: pointer;\n  }\n  \n  .dm-tabs button.dm-selected {\n    background: #168ff0;\n    border-color: #168ff0;\n    color: white;\n  }\n  \n  .dm-search {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    border: 1px solid #dce4ee;\n    border-radius: 8px;\n    padding: 5px 6px 5px 12px;\n    color: #8494a5;\n  }\n  \n  .dm-search input {\n    border: 0;\n    outline: 0;\n    min-width: 240px;\n    font-size: 13px;\n    padding: 7px 2px;\n    background: transparent;\n  }\n  \n  .dm-search button {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    border: 0;\n    background: #edf2f7;\n    border-radius: 6px;\n    padding: 8px 10px;\n    cursor: pointer;\n    color: #516479;\n  }\n  \n  .dm-count {\n    margin: 24px 0 10px;\n    color: #728198;\n    font-size: 13px;\n  }\n  \n  .dm-count strong {\n    color: #203047;\n  }\n  \n  .dm-table-wrap {\n    overflow-x: auto;\n  }\n  \n  .dm-table {\n    width: 100%;\n    table-layout: fixed;\n    border-collapse: collapse;\n    text-align: center;\n    font-size: 13px;\n  }\n  \n  .dm-table th {\n    background: #f4f7fb;\n    color: #43536b;\n    font-weight: 700;\n    padding: 15px 12px;\n    border-top: 1px solid #dce5f0;\n    border-bottom: 1px solid #dce5f0;\n    white-space: nowrap;\n  }\n  \n  .dm-table td {\n    padding: 15px 12px;\n    border-bottom: 1px solid #edf0f5;\n    white-space: nowrap;\n  }\n  \n  .dm-table tbody tr:hover {\n    background: #f8fbff;\n  }\n  \n  .dm-id {\n    font-weight: 600;\n    color: #365a85;\n  }\n  \n  .dm-time {\n    color: #52647a;\n  }\n  \n  .dm-status {\n    display: inline-block;\n    min-width: 57px;\n    padding: 5px 9px;\n    border-radius: 5px;\n    font-weight: 700;\n  }\n  \n  .dm-ok {\n    background: #e4f7eb;\n    color: #149457;\n  }\n  \n  .dm-bad {\n    background: #ffe9e9;\n    color: #d64343;\n  }\n  \n  .dm-empty {\n    padding: 50px !important;\n    color: #8895a6;\n  }\n  \n  .dm-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    margin-top: 20px;\n    color: #7b8a9b;\n    font-size: 13px;\n  }\n  \n  .dm-pagination {\n    display: flex;\n    gap: 5px;\n    flex-wrap: wrap;\n  }\n  \n  .dm-pagination button {\n    background: white;\n    border: 1px solid #e0e6ee;\n    border-radius: 6px;\n    padding: 7px 11px;\n    color: #52637b;\n    cursor: pointer;\n  }\n  \n  .dm-pagination button.dm-current {\n    background: #168ff0;\n    color: #fff;\n    border-color: #168ff0;\n  }\n  \n  .dm-pagination button:disabled {\n    opacity: .4;\n    cursor: default;\n  }\n  \n  .dm-note {\n    color: #8b98aa;\n    font-size: 12px;\n    margin: 14px 3px;\n  }\n  \n  @media (max-width: 900px) {\n    .dm-heading {\n      align-items: flex-start;\n    }\n    .dm-toolbar {\n      align-items: stretch;\n    }\n    .dm-search {\n      width: 100%;\n    }\n    .dm-search input {\n      min-width: 0;\n      flex: 1;\n    }\n    .dm-footer {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  }\n  \n  /* 장비관리 표 영역 높이 유지 */\n\n  /* 장비 관리 리디자인 페이지 레이아웃 */\n.device-management-layout .device-management-content {\n  flex: 1;\n  min-width: 0;\n  padding: 20px 28px 24px;\n  box-sizing: border-box;\n}\n\n.device-management-layout .dm-page {\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.device-management-layout .dm-panel {\n  width: 100%;\n  max-width: none;\n  box-sizing: border-box;\n}\n\n/* =========================================\n   장비 관리 글씨 크기 통일\n   사용자 관리 목록과 동일한 기준\n========================================= */\n\n/* 페이지 제목 */\n.device-management-layout .dm-heading h2 {\n  font-size: 24px;\n}\n\n/* 설명 및 전체 건수 */\n.device-management-layout .dm-heading p,\n.device-management-layout .dm-total {\n  font-size: 14px;\n}\n\n/* 플러그 / 스위치 / 감지기 탭 */\n.device-management-layout .dm-tabs button {\n  font-size: 15px;\n}\n\n/* 검색창 */\n.device-management-layout .dm-search input,\n.device-management-layout .dm-search button {\n  font-size: 14px;\n}\n\n/* 목록 건수 */\n.device-management-layout .dm-count {\n  font-size: 16px;\n  margin: 18px 0 10px;\n}\n\n/* 장비 목록 */\n.device-management-layout .dm-table {\n  font-size: 15px;\n}\n\n/* 테이블 헤더 */\n.device-management-layout .dm-table th {\n  font-size: 15px;\n  padding: 12px 9px;\n}\n\n/* 테이블 데이터 */\n.device-management-layout .dm-table td {\n  font-size: 15px;\n  padding: 10px 9px;\n}\n\n/* 상태 표시 */\n.device-management-layout .dm-status {\n  font-size: 14px;\n}\n\n/* 페이지네이션 */\n.device-management-layout .dm-footer,\n.device-management-layout .dm-pagination button {\n  font-size: 14px;\n}\n\n.device-management-layout .dm-footer {\n  margin-top: 14px;\n}\n\n/* 하단 안내 문구 */\n.device-management-layout .dm-note {\n  font-size: 13px;\n}\n\n/* 장비 관리 테이블 세로 공간 활용 */\n\n/* 테이블 헤더 */\n.device-management-layout .dm-table th {\n  padding: 17px 9px;\n}\n\n/* 테이블 데이터 행 */\n.device-management-layout .dm-table td {\n  padding: 17px 9px;\n}\n\n/* 테이블과 페이지네이션 사이 */\n.device-management-layout .dm-footer {\n  margin-top: 20px;\n}\n\n/* 하단 안내 문구 */\n.device-management-layout .dm-note {\n  margin-top: 18px;\n}\n/* 사용자관리 기준 디자인 통일 */\n.dm-page {\n  color: #26354a;\n  font-family: 'Malgun Gothic', Arial, sans-serif;\n}\n\n.dm-heading h2 {\n  font-size: 21px;\n  margin-bottom: 6px;\n}\n\n.dm-panel {\n  padding: 22px;\n  border-radius: 10px;\n}\n\n.dm-table {\n  font-size: 12px;\n}\n\n.dm-table th {\n  background: #f1f5fa;\n  color: #3b4c62;\n  border-top: 2px solid #2196f3;\n  border-bottom: none;\n  padding: 14px 9px;\n}\n\n.dm-table td {\n  padding: 13px 9px;\n  border-bottom: 1px solid #e8edf3;\n}\n\n.dm-table tbody tr:hover {\n  background: #f1f8ff;\n}\n\n.dm-pagination button {\n  border-radius: 5px;\n  padding: 7px 10px;\n}\n\n.dm-footer {\n  font-size: 12px;\n}\n\n/* 페이지 이동 시 테이블 높이 및 셀 크기 고정 */\n.dm-table-wrap {\n  min-height: 565px;\n}\n\n.dm-table {\n  table-layout: fixed;\n}\n\n.dm-table thead tr {\n  height: 48px;\n}\n\n.dm-table tbody tr {\n  height: 55px;\n}\n\n.dm-table td {\n  box-sizing: border-box;\n  height: 55px;\n  vertical-align: middle;\n}\n\n.dm-table .dm-time {\n  white-space: nowrap;\n}\n\n/* 장비관리 설치위치 전체 주소 표시 */\n.dm-table td.dm-location {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: keep-all;\n  text-align: left;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
